"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftProposalCancelDto = instanceOfShiftProposalCancelDto;
exports.ShiftProposalCancelDtoFromJSON = ShiftProposalCancelDtoFromJSON;
exports.ShiftProposalCancelDtoFromJSONTyped = ShiftProposalCancelDtoFromJSONTyped;
exports.ShiftProposalCancelDtoToJSON = ShiftProposalCancelDtoToJSON;
exports.ShiftProposalCancelDtoToJSONTyped = ShiftProposalCancelDtoToJSONTyped;
/**
 * Check if a given object implements the ShiftProposalCancelDto interface.
 */
function instanceOfShiftProposalCancelDto(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    return true;
}
function ShiftProposalCancelDtoFromJSON(json) {
    return ShiftProposalCancelDtoFromJSONTyped(json, false);
}
function ShiftProposalCancelDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'nurseProfileId': json['nurseProfileId'],
    };
}
function ShiftProposalCancelDtoToJSON(json) {
    return ShiftProposalCancelDtoToJSONTyped(json, false);
}
function ShiftProposalCancelDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'nurseProfileId': value['nurseProfileId'],
    };
}
//# sourceMappingURL=ShiftProposalCancelDto.js.map